const metrics = [
  {
    icon: 'ri-timer-line',
    title: 'Время выхода на KPI',
    desc: 'Сколько недель/месяцев нужно новичку, чтобы достичь плановых показателей. Хороший результат — 2-3 месяца вместо 6-12 без системы адаптации.',
  },
  {
    icon: 'ri-user-unfollow-line',
    title: 'Текучесть в первые 3-6 месяцев',
    desc: 'Процент сотрудников, уволившихся на испытательном сроке. Целевой показатель — менее 10%. Без адаптации этот показатель достигает 30-40%.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Вовлечённость',
    desc: 'Измеряется опросниками, вовлечённостью в командные мероприятия и инициативностью. Сотрудники с качественным онбордингом вовлечены на 20-40% выше.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Оценка руководителя',
    desc: 'Структурированная оценка компетенций и результатов сотрудника на контрольных точках. Позволяет объективно принять решение о прохождении испытательного срока.',
  },
  {
    icon: 'ri-edit-circle-line',
    title: 'Самооценка сотрудника',
    desc: 'Как сам сотрудник оценивает свой прогресс, понимание задач и комфорт в компании. Расхождение с оценкой руководителя — сигнал к корректировке плана.',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Итоговая эффективность',
    desc: 'Интегральный показатель: выполнение KPI + оценка компетенций + обратная связь команды. На основе этого принимается решение о прохождении испытательного срока.',
  },
];

export default function MeasureEffectiveness() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как измерять эффективность адаптации
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Без метрик адаптация — «чёрный ящик». Непонятно, работает система или нет. Вот шесть показателей, которые дают объективную картину онбординга.
        </p>

        <div className="flex flex-col items-center max-w-lg mx-auto">
          {metrics.map((item, i) => (
            <div key={i} className="flex flex-col items-center w-full">
              <div className="bg-teal-600 rounded-xl p-5 w-full text-center">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className={`${item.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-white font-bold text-lg mb-1">{item.title}</h3>
                <p className="text-teal-100 text-sm leading-relaxed">{item.desc}</p>
              </div>
              {i < metrics.length - 1 && (
                <div className="flex items-center gap-1 py-2">
                  <span className="text-teal-400 text-lg font-bold">↓</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}